'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledSmall = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'RequiredOnboardingSubtext__StyledSmall'
})(['&&&{line-height:40px;}']);

var RequiredOnboardingSubtext = function RequiredOnboardingSubtext(_ref) {
  var billingNameKey = _ref.billingNameKey,
      price = _ref.price,
      currencyCode = _ref.currencyCode;

  return _react2.default.createElement(
    StyledSmall,
    null,
    _react2.default.createElement(_FormattedJSXMessage2.default, {
      message: 'pricingPage.calculator.requiredOnboarding.' + billingNameKey + '_jsx',
      options: { currencyCode: currencyCode, price: price },
      elements: { PriceDisplay: _PriceDisplay2.default, UILink: _UILink2.default, b: _styledComponents2.default.b.withConfig({
          displayName: 'RequiredOnboardingSubtext__b'
        })(['']) }
    })
  );
};

exports.default = RequiredOnboardingSubtext;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/RequiredOnboardingSubtext.js
// module id = 744
// module chunks = 3 4